import getConfig from 'next/config';
import { useRouter } from 'next/router';
import React, { useContext, useRef, useState } from 'react';
import AppConfig from '../../../layout/AppConfig';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import { LayoutContext } from '../../../layout/context/layoutcontext';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { Toast } from 'primereact/toast';
import { useFormik } from "formik";
import * as Yup from "yup";
import { connect } from 'react-redux';
import { UsuarioActions, UsuarioSelectors } from '../../../model/redux/reducers/UsuarioReducer';
import { useGlobalMessage } from '../../../components/ui/global_message';

const LoginPage = (props) => {
    const [checked, setChecked] = useState(false);
    const { layoutConfig } = useContext(LayoutContext);
    const contextPath = getConfig().publicRuntimeConfig.contextPath;
    const router = useRouter();
    const containerClassName = classNames('surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden', { 'p-input-filled': layoutConfig.inputStyle === 'filled' });
    const toast = useRef();
    const { showMessage } = useGlobalMessage();

    const showErrorInternal = (message) => {
        toast.current.show({ severity: 'error', summary: 'Validación', detail: message, life: 3000 });
    };

    const navegarInicio = (usuario) => {
        router.push("/");
    }

    const showNotification = (data) => {

        const notification = data?.payload?.notificacionCompania;

        if(notification){

            const params = {
                severity: notification?.color??'info', // tipos: success, info, warn, error
                summary: 'Notificación',
                detail: notification?.mensaje,
                closable: notification?.dismissable??true
            }

            if((notification?.show_temp??0) > 0){
                params.life = notification?.show_temp;
            }else{
                params.sticky = true;
            }

            showMessage(params);
            
        }
        
    };

    const formik = useFormik({
        initialValues: {
            username: "",
            password: "",
        },
        validationSchema: Yup.object({
            username: Yup.string()
                .required("Requerido")
                .max(20, "El nombre de usuario no puede tener más de 20 caracteres."),
            password: Yup.string()
                .required("Requerido")
                .min(4, "La contraseña debe tener al menos 4 caracteres."),
        }),
        onSubmit: async (values) => {
            //Realizo la autenticacion del usuario.
            let response = await props.autenticarUsuario(values.username, values.password);
            if (response?.error) {
                showErrorInternal(response?.error?.message);
                return;
            }
            showNotification(response);
            navegarInicio();
        },
    });



    return (
        <div className={containerClassName}>
            <div className="flex flex-column align-items-center justify-content-center">
                <title>AttendCheck</title>
                <img src={`${contextPath}/layout/images/logo.png`} alt="Company Logo" className="mb-5 w-6rem flex-shrink-0" />
                <div style={{ borderRadius: '56px', padding: '0.3rem', background: 'linear-gradient(180deg, red 10%, rgba(20, 20, 23, 0) 35%)' }}>
                    <div className="w-full surface-card py-8 px-5 sm:px-8" style={{ borderRadius: '53px' }}>
                        <div className="text-center mb-1">
                            <img src={`${contextPath}/demo/images/login/avatarpeople.png`} alt="Image" height="50" className="mb-1" />
                            <div className="text-900 text-3xl font-medium mb-3">Bienvenido!</div>
                            <span className="text-600 font-medium">Iniciar Sesión, para continuar</span>
                        </div>

                        <form onSubmit={formik.handleSubmit}>

                            <label htmlFor="usuario1" className="block text-900 text-xl font-medium mb-2">
                                Usuario
                            </label>
                            <Toast ref={toast} />
                            <InputText
                                type="text"
                                id='username'
                                name='username'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.username}
                                inputid="username" aria-describedby="usuario-help" placeholder="Usuario" className="w-full md:w-30rem mb-1" style={{ padding: '1rem' }} />
                            {formik.touched.username && formik.errors.username ? (
                                <label className='block p-error'>{formik.errors.username}</label>
                            ) : null}

                            <label htmlFor="password" className="block text-900 font-medium text-xl mt-5 mb-2">
                                Contraseña
                            </label>
                            <Password
                                id='password'
                                name='password'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.password}

                                placeholder="Contraseña" toggleMask className="w-full mb-1" inputClassName='w-full p-3 md:w-30rem'></Password>
                            {formik.touched.password && formik.errors.password ? (
                                <label className='block p-error'>{formik.errors.password}</label>
                            ) : null}
                            <div className="flex align-items-center justify-content-between mt-2 mb-2 gap-5">
                                <div className="flex align-items-center">
                                    {/* <Checkbox inputid="rememberme1" checked={checked} onChange={(e) => setChecked(e.checked)} className="mr-2"></Checkbox>
                                    <label htmlFor="rememberme1">
                                        Remember me
                                    </label> */}
                                </div>

                            </div>
                            <Button type='submit' severity="danger" label="Iniciar Sesión" className="w-full p-3 text-xl" ></Button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

LoginPage.getLayout = function getLayout(page) {
    return (
        <React.Fragment>
            {page}
            <AppConfig simple />
        </React.Fragment>
    );
};

function mapSateToProps(state) {

    const fetchingData = UsuarioSelectors.statusData(state);
    const loading = (fetchingData === 'loading')

    return { loading };
}

function mapDispatchToProps(dispatch) {
    const autenticarUsuario = (usuario, password) =>
        dispatch(UsuarioActions.autenticarUsuario({ usuario, password }));
    return { autenticarUsuario };
}

export default connect(mapSateToProps, mapDispatchToProps)(LoginPage);
